import React, { useImperativeHandle, useRef } from "react";
import { Password as PasswordLib, PasswordRef } from "@npm_leadtech/qr-ui-components";

import { PasswordAdapterProps } from "./types";

import { useAdapterLogic } from "./hooks";

export const PasswordAdapter = React.forwardRef<PasswordRef, PasswordAdapterProps>((props, ref) => {
  const internalRef = useRef<PasswordRef>(null);

  useImperativeHandle(ref, () => internalRef.current as PasswordRef, []);

  const passwordProps = useAdapterLogic(props, internalRef);

  return <PasswordLib {...passwordProps} />;
});
PasswordAdapter.displayName = "PasswordAdapter";
